export enum SrsBallotReviewOutcome {
    FinaliseWithoutReview = 0,
    Submit = 1,
    Approve = 2,
    Reject = 3,
    NotApplicable = 4,
    CompletedApprovalNotRequired = 5
}